import grid1 from './images/1.jpg'
import grid2 from './images/2.jpg'
import grid3 from './images/3.jpg'
import grid4 from './images/4.jpg'
import grid5 from './images/5.jpg'
import grid6 from './images/6.jpg'

export const IntroSection: React.FC = () => {
  return (
    <section className="bg-white py-14 px-6">
      <div className="max-w-md mx-auto flex flex-col gap-8 items-center">
        <div className="flex flex-col gap-4 items-center text-center text-black px-5 pb-4">
          <h2 className="text-[24px] font-bold leading-[1.4] tracking-[-0.02em]">こんなバラ、見たことない！</h2>
          <p className="text-[14px] leading-[1.6] text-black">
            私たちがお届けするのは、
            <br />
            お花屋さんでもなかなか出会えないバラ。
            <br />
            <br />
            でも、品種のめずらしさだけで
            <br />
            選んでいるわけではありません。
            <br />
            <br />
            色や咲き方、生産者による違いも見ながら
            <br />
            フローリストが本気で「かわいい！」と
            <br />
            思えるものを厳選。
            <br />
            <br />
            同じ花、なのに毎回違う。
            <br />
            ひとクセあるセレクトをお楽しみください。
          </p>
        </div>

        <div className="flex gap-2.5 w-full">
          <div className="flex-1 flex flex-col gap-2.5">
            <img src={grid1} alt="" className="w-full aspect-182/250 object-cover rounded-lg" />
            <img src={grid2} alt="" className="w-full aspect-182/130 object-cover rounded-lg" />
            <img src={grid3} alt="" className="w-full aspect-182/230 object-cover rounded-lg" />
          </div>
          <div className="flex-1 flex flex-col gap-2.5">
            <img src={grid4} alt="" className="w-full aspect-182/175 object-cover rounded-lg" />
            <img src={grid5} alt="" className="w-full aspect-182/260 object-cover rounded-lg" />
            <img src={grid6} alt="" className="w-full aspect-182/175 object-cover rounded-lg" />
          </div>
        </div>
      </div>
    </section>
  )
}
